export default __webpack_public_path__ + "static/tableau-1b205a9c5bd7aab2c15994d7fb1e95aa.png";